export const storeUserCredentials = async (
  username: string,
  password: string
) => undefined;

export const retrieveUserCredentials = async () => undefined;
export const removeUserCredentials = async () => undefined;
